import _ from 'underscore';

import { allMetrics, defaultMetrics, AccountsMode } from '@bingads-webui-campaign/overview-cards-common';

const validMetricIndexes = [0, 1, 2, 3];
const defaultSelectedMetricIndexes = [0, 1];

export const getDefaultPerformanceChartPreference = ({
  permissions,
}) => ({
  selectedMetricIndexes: defaultSelectedMetricIndexes,
  metrics: defaultMetrics(permissions, 1),
});

export const getPropsFromPreferenceForPerformanceChart = ({
  cardPreference,
  patchPreference,
  campaignType,
}) => {
  const shellContentElement = document.querySelector('.app-shell-content');

  return {
    ...cardPreference,
    patchPreference,
    shellContentElement,
    campaignType,
  };
};

export const isPerformanceChartPreferenceValid = ({
  cardPreference,
  permissions,
  campaignType,
}) => {
  const availableMetricKeys = allMetrics(permissions, AccountsMode.Expert, campaignType);
  if (!cardPreference
    || !_.isArray(cardPreference.metrics)
    || _.some(cardPreference.metrics, metric => !availableMetricKeys.includes(metric))
    || cardPreference.metrics.length !== 4
    || !_.isArray(cardPreference.selectedMetricIndexes)
    || cardPreference.selectedMetricIndexes.length > 4
    || _.some(cardPreference.selectedMetricIndexes, index => !validMetricIndexes.includes(index))
  ) {
    return false;
  }

  return true;
};
